import { useRouter } from "next/router";
import { isLocalPatientsPathname } from "../utils/zoneRoutes";
function useCheckWorklistContainer() {
  var _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  if (isLocalPatientsPathname(pathname) || pathname === "/") {
    return true;
  }
  return false;
}
export default useCheckWorklistContainer;